import {Component, Input, OnInit} from '@angular/core';
import {NavigationExtras} from '@angular/router';

@Component({
  selector: 'app-gauge',
  templateUrl: './gauge.component.html',
  styleUrls: ['./gauge.component.scss'],
})
export class GaugeComponent implements OnInit {
  @Input() value: { current: number; max: number };
  @Input() route: { commands: any[]; extras?: NavigationExtras } = {commands: []};
  constructor() { }

  ngOnInit() {}

  getProgressionValue(): number {
    return this.value.current / this.value.max;
  }
}
